import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSecurityRuleFunctionalityList,
  fetchSecurityRuleFunctionalityById,
  createSecurityRuleFunctionality,
  updateSecurityRuleFunctionality,
  deleteSecurityRuleFunctionality,
} from "@/apis/security/securityRulesFunctionalityApi";

const slice = createSlice({
  name: "securityRulesFunctionality",
  initialState: {
    list: [],
    current: null,
    listLoading: false,
    loading: false,      // for fetchById
    saving: false,       // for create
    deleting: false,     // for delete
    updating: false      // for update
  },
  reducers: {
    clearCurrentFunctionality(state) {
      state.current = null;
    },
  },
  extraReducers: (b) => {
    b
      // fetchAll
      .addCase(fetchSecurityRuleFunctionalityList.pending, (s) => { s.listLoading = true })
      .addCase(fetchSecurityRuleFunctionalityList.fulfilled, (s, a) => { s.list = a.payload; s.listLoading = false })
      .addCase(fetchSecurityRuleFunctionalityList.rejected, (s) => { s.listLoading = false })
      // fetchById
      .addCase(fetchSecurityRuleFunctionalityById.pending, (s) => { s.loading = true })
      .addCase(fetchSecurityRuleFunctionalityById.fulfilled, (s, a) => { s.current = a.payload; s.loading = false })
      .addCase(fetchSecurityRuleFunctionalityById.rejected, (s) => { s.loading = false })

      // create
      .addCase(createSecurityRuleFunctionality.pending, (s) => { s.saving = true })
      .addCase(createSecurityRuleFunctionality.fulfilled, (s) => { s.saving = false })
      .addCase(createSecurityRuleFunctionality.rejected, (s) => { s.saving = false })

      // update
      .addCase(updateSecurityRuleFunctionality.pending, (s) => { s.updating = true })
      .addCase(updateSecurityRuleFunctionality.fulfilled, (s) => { s.updating = false })
      .addCase(updateSecurityRuleFunctionality.rejected, (s) => { s.updating = false })

      // delete
      .addCase(deleteSecurityRuleFunctionality.pending, (s) => { s.deleting = true })
      .addCase(deleteSecurityRuleFunctionality.fulfilled, (s) => { s.deleting = false })
      .addCase(deleteSecurityRuleFunctionality.rejected, (s) => { s.deleting = false });
  },
});

export const { clearCurrentFunctionality } = slice.actions;
export default slice.reducer;
